import {onlyIfForm, useSelector} from '../../../../store.js'
import ConfirmModal from '../../../../common/components/Modal/ConfirmModal.js'
import ButtonPrimary from '../../../../common/components/Button/ButtonPrimary.js'
import {
  closeModal,
  modalFormSelector,
  applyFilter,
  clearFilters,
  TRANSFER_LIST_FILTER_OPTIONS,
  errorsSelector,
  updateModalForm,
  modalValidDateRangeFilterTypesOptionsSelector,
  DATE_RANGE_FILTER_PANEL,
  MISC_FILTER_PANEL,
  RECEIVING_WAREHOUSE_FILTER_PANEL,
  SENDING_WAREHOUSE_FILTER_PANEL,
} from './transferListFilterModalFunctions.js'
import {
  filterOrderSelector,
  showFilterSettingsModal,
} from '../../../Modals/FilterSettingsModal.js'
import Icon from '../../../../common/icons/Icon.js'
import DateRangeFilterPanel from '../../../OrderListPage/Modals/OrderListFilterModal/DateRangeFilterPanel.js'
import MiscFilterPanel from './MiscFilterPanel.js'
import ReceivingWarehouseFilterPanel from './ReceivingWarehouseFilterPanel.js'
import SendingWarehouseFilterPanel from './SendingWarehouseFilterPanel.js'

const FILTER_PANEL_LIST = {
  [DATE_RANGE_FILTER_PANEL]: DateRangeFilterPanel,
  [SENDING_WAREHOUSE_FILTER_PANEL]: SendingWarehouseFilterPanel,
  [RECEIVING_WAREHOUSE_FILTER_PANEL]: ReceivingWarehouseFilterPanel,
  [MISC_FILTER_PANEL]: MiscFilterPanel,
}
const FILTER_ORDER_SETTINGS_KEY = 'transfer.list.filter_order'

function showTransferListFilterSettingsModal() {
  showFilterSettingsModal({
    title: 'Transfer Line Filter Settings',
    userSettingsKey: FILTER_ORDER_SETTINGS_KEY,
    listOptions: TRANSFER_LIST_FILTER_OPTIONS,
  })
}

function TransferListFilterModal() {
  const filterList = useSelector((state) =>
    filterOrderSelector(state, {
      userSettingsKey: FILTER_ORDER_SETTINGS_KEY,
      listOptions: TRANSFER_LIST_FILTER_OPTIONS,
    }),
  )

  return (
    <ConfirmModal
      title="Transfer Filters"
      modalSize="md"
      className="modal--order-list-filters"
      onConfirm={() => applyFilter()}
      onCancel={() => closeModal()}
      confirmText="Apply"
      cancelText="Cancel"
      preventHotKeyConfirm
      RightButtons={() => (
        <div className="flex--justify">
          <ButtonPrimary
            isOutlined
            className="btn--sm margin-right-10"
            onClick={() => clearFilters()}
          >
            Clear Filters
          </ButtonPrimary>
          <ButtonPrimary
            isOutlined
            className="btn--sm"
            onClick={() => showTransferListFilterSettingsModal()}
          >
            <Icon name="sym-settings" className="fs-01" />
          </ButtonPrimary>
        </div>
      )}
    >
      {filterList.map((item) => {
        const Panel = FILTER_PANEL_LIST[item]

        return Panel ? (
          <Panel
            key={item}
            modalFormSelector={modalFormSelector}
            errorsSelector={errorsSelector}
            updateModalForm={updateModalForm}
            modalValidDateRangeFilterTypesOptionsSelector={
              modalValidDateRangeFilterTypesOptionsSelector
            }
          />
        ) : null
      })}
    </ConfirmModal>
  )
}

export default onlyIfForm(TransferListFilterModal, modalFormSelector)
